(function () {
  'use strict';

  var capture = document.querySelector('[data-fl-tool-capture]');
  var capturePanel = capture && capture.querySelector('.fl-tool-capture__panel');
  var previousFocus = null;
  var captureInertedElements = [];
  var captureInertObserver = null;

  if (!window.FLToolDialogIsolation) {
    var activeToolDialog = null;
    var toolDialogAllowed = [];
    var toolDialogRecords = [];
    var toolDialogObserver = null;

    function restoreToolDialogBackground() {
      if (toolDialogObserver) toolDialogObserver.disconnect();
      toolDialogRecords.forEach(function (record) {
        if (!record.element || !record.element.isConnected) return;
        if (record.hadInert) record.element.setAttribute('inert', '');
        else record.element.removeAttribute('inert');
        if (record.ariaHidden === null) record.element.removeAttribute('aria-hidden');
        else record.element.setAttribute('aria-hidden', record.ariaHidden);
      });
      toolDialogRecords = [];
      toolDialogAllowed = [];
      activeToolDialog = null;
    }

    function isolateToolDialogSibling(element) {
      if (!(element instanceof HTMLElement) || toolDialogAllowed.indexOf(element) !== -1) return;
      if (/^(SCRIPT|STYLE|LINK|TEMPLATE)$/.test(element.tagName)) return;
      toolDialogRecords.push({
        element: element,
        hadInert: element.hasAttribute('inert'),
        ariaHidden: element.getAttribute('aria-hidden')
      });
      element.setAttribute('inert', '');
      element.setAttribute('aria-hidden', 'true');
    }

    window.FLToolDialogIsolation = {
      open: function (dialog, companions) {
        if (!(dialog instanceof HTMLElement)) return;
        restoreToolDialogBackground();
        activeToolDialog = dialog;
        toolDialogAllowed = [dialog].concat(Array.isArray(companions) ? companions.filter(Boolean) : []);
        Array.prototype.forEach.call(document.body.children, isolateToolDialogSibling);
        toolDialogObserver = new MutationObserver(function (records) {
          records.forEach(function (record) {
            Array.prototype.forEach.call(record.addedNodes, isolateToolDialogSibling);
          });
        });
        toolDialogObserver.observe(document.body, { childList: true });
      },
      close: function (dialog) {
        if (dialog && activeToolDialog && dialog !== activeToolDialog) return;
        restoreToolDialogBackground();
      }
    };
  }

  function makeCaptureBackgroundInert(element) {
    if (!(element instanceof HTMLElement) || element === capture) return;
    if (/^(SCRIPT|STYLE|LINK|TEMPLATE)$/.test(element.tagName) || element.hasAttribute('inert')) return;
    captureInertedElements.push({ element: element, ariaHidden: element.getAttribute('aria-hidden') });
    element.setAttribute('inert', '');
    element.setAttribute('aria-hidden', 'true');
  }

  function setCaptureBackgroundInert(active) {
    if (active) {
      Array.prototype.forEach.call(document.body.children, makeCaptureBackgroundInert);
      if (!captureInertObserver) {
        captureInertObserver = new MutationObserver(function (records) {
          records.forEach(function (record) {
            Array.prototype.forEach.call(record.addedNodes, makeCaptureBackgroundInert);
          });
        });
      }
      captureInertObserver.observe(document.body, { childList: true });
      return;
    }

    if (captureInertObserver) captureInertObserver.disconnect();
    captureInertedElements.forEach(function (record) {
      if (!record.element) return;
      record.element.removeAttribute('inert');
      if (record.ariaHidden === null) record.element.removeAttribute('aria-hidden');
      else record.element.setAttribute('aria-hidden', record.ariaHidden);
    });
    captureInertedElements = [];
  }

  function focusable(root) {
    return Array.prototype.slice.call(root.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]):not([tabindex="-1"]), select:not([disabled]):not([tabindex="-1"]), textarea:not([disabled]):not([tabindex="-1"]), [tabindex]:not([tabindex="-1"])'
    )).filter(function (element) { return !element.hidden && element.offsetParent !== null; });
  }

  function openCapture(trigger) {
    if (!capture) return;
    var activeElement = document.activeElement;
    previousFocus = trigger || (activeElement && activeElement !== document.body ? activeElement : null) || document.querySelector('[data-fl-tool-capture-open]') || document.querySelector('main');
    if (capture.parentNode !== document.body) document.body.appendChild(capture);
    capture.hidden = false;
    capture.removeAttribute('inert');
    capture.setAttribute('aria-hidden', 'false');
    setCaptureBackgroundInert(true);
    document.documentElement.classList.add('fl-tool-capture-open');
    var target = capture.querySelector('input[type="email"]') || capture.querySelector('[data-fl-tool-capture-close]');
    if (target) target.focus({ preventScroll: true });
  }

  function closeCapture() {
    if (!capture) return;
    capture.hidden = true;
    capture.setAttribute('inert', '');
    capture.setAttribute('aria-hidden', 'true');
    setCaptureBackgroundInert(false);
    document.documentElement.classList.remove('fl-tool-capture-open');
    if (previousFocus && previousFocus.isConnected && typeof previousFocus.focus === 'function') {
      var restoreTarget = previousFocus;
      var needsTemporaryTabindex = restoreTarget.matches && !restoreTarget.matches('a[href], button, input, select, textarea, [tabindex]');
      if (needsTemporaryTabindex) restoreTarget.setAttribute('tabindex', '-1');
      restoreTarget.focus({ preventScroll: true });
      if (needsTemporaryTabindex) restoreTarget.addEventListener('blur', function cleanupRestoreTarget() {
        restoreTarget.removeAttribute('tabindex');
      }, { once: true });
    }
  }

  document.addEventListener('click', function (event) {
    var openButton = event.target.closest('[data-fl-tool-capture-open]');
    if (openButton) { event.preventDefault(); openCapture(openButton); return; }

    if (event.target.closest('[data-fl-tool-capture-close]')) {
      event.preventDefault();
      closeCapture();
      return;
    }

    var copyButton = event.target.closest('[data-fl-tool-copy-link]');
    if (copyButton) {
      var suite = copyButton.closest('.fl-suite');
      var output = suite && suite.querySelector('[data-fl-tool-suite-status]');
      var url = window.location.href;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(function () {
          if (output) output.textContent = 'Link copied';
          window.setTimeout(function () { if (output) output.textContent = ''; }, 1800);
        }).catch(function () { window.prompt('Copy this link:', url); });
      } else {
        window.prompt('Copy this link:', url);
      }
    }
  });

  if (capture) {
    capture.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') { event.preventDefault(); closeCapture(); return; }
      if (event.key !== 'Tab' || !capturePanel) return;
      var items = focusable(capturePanel);
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
  }

  document.querySelectorAll('.fl-practice-list__form').forEach(function (form) {
    form.setAttribute('data-shopify-captcha', 'true');
    form.addEventListener('submit', function (event) {
      var honeypot = form.querySelector('[name="contact[website]"]');
      if (honeypot && honeypot.value) { event.preventDefault(); return; }
      var submit = form.querySelector('[data-fl-list-submit]');
      var label = form.querySelector('[data-fl-list-submit-label]');
      if (submit) submit.disabled = true;
      if (label) label.textContent = 'Sending…';
      window.setTimeout(function () {
        if (!form.isConnected) return;
        if (submit) submit.disabled = false;
        if (label) label.textContent = 'Join the email list';
      }, 12000);
    });
  });

  window.addEventListener('pageshow', function () {
    document.querySelectorAll('.fl-practice-list__form').forEach(function (form) {
      var submit = form.querySelector('[data-fl-list-submit]');
      var label = form.querySelector('[data-fl-list-submit-label]');
      if (submit) submit.disabled = false;
      if (label) label.textContent = 'Join the email list';
    });
  });

  var serverMessage = capture && capture.querySelector('.fl-practice-list__success, .fl-practice-list__error');
  if (serverMessage) {
    openCapture(null);
    try {
      var params = new URLSearchParams(window.location.search);
      params.delete('tools_joined');
      params.delete('customer_posted');
      params.delete('contact_posted');
      var query = params.toString();
      window.history.replaceState({}, '', window.location.pathname + (query ? '?' + query : '') + window.location.hash);
    } catch (error) {}
  }
})();
